import { Link } from 'react-router-dom';
import styled from "styled-components";

const StyledLink = styled(Link)`
  text-decoration: none;
  color: white;
  // padding: 40px;
  font-size: 20px;

  &:hover {
    background-color: black;
    color: white;
  }

  @media (max-width: 750px) {
    font-size: 13px;
    padding: 30px;
  }
`;

function Footer() {
    return (
        <div>
            <section id="footer">
                    <div id="footerItems">
                        <a href="https://www.instagram.com/lobo.powerlifting" target="_blank">
                        <img src="/images/instagram-white-icon.webp"></img>
                        </a>
                        © 2025 University of New Mexico Lobo Powerlifting                    
                    </div>
            </section>
        </div>
    );
}

export default Footer;
